module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/logo_visit-reserve-8f1297d415b56e73d0a1e05782914ae3.png";